import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RotationMeter from './RotationKpiMeter';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiModels from '../../../models/kpiModels';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as dataHelper from '../../../helpers/dataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class KpiDescription extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang:this.props.lang,
            kpi: this.props.kpi,
            locale: appHelper.getLocalData(this.props.kpi),

        };

        this.show = this.show.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
    }

    componentDidMount() {

        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.kpi)
            });
        }
    }

    show() {
        let optionRef = this.refs[`${this.state.kpi.kpi_id}_description`];
        TweenLite.set(optionRef, {height: "auto", opacity: 1});
        TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
            height: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.handleProgression);
    }

    handleProgression() {
        if(appHelper.isDefined(this.props.callbacks)) {
            this.props.callbacks.onObjectComplete(this.state.kpi);
        }
    }

    render() {
        return (

                <div className="kpi-overview-row" ref={`${this.state.kpi.kpi_id}_description`} >
                    <div className="kpi-meter-col" role="presentation">
                        <RotationMeter bite_id={this.props.bite_id}
                                       kpiDefaults={this.state.kpi}
                                       meterParams={kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS}
                                       displayState={kpiConstants.KPI_DISPLAY_STATE_START}/>
                    </div>
                    <div className="kpi-content-col">
                        {appHelper.isDefined(this.state.locale.long_title) && this.state.locale.long_title !== null && this.state.locale.long_title.length > 0
                            ?
                            <h4><strong>{this.state.locale.long_title}</strong></h4>
                            : null
                        }
                        {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                            ?
                            <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                            : null
                        }
                    </div>
                </div>

        );
    }
}

KpiDescription.propTypes = {
    kpi: PropTypes.object.isRequired,
    bite_id: PropTypes.number.isRequired,
    callbacks: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

KpiDescription.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KpiDescription);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiDescription.js
 **/